const stockLocation = {
    location: document.getElementById('jsLocation') as HTMLElement, 
    locationWrap: document.querySelectorAll('jsLocationWrap') as NodeListOf <HTMLElement>,

    init() {
        this.setLocation()
    }, 

    setLocation() {
        this.locationWrap.forEach(item => {
            item.innerHTML = this.location.innerHTML;
        })
    }
}

export default stockLocation
